import React from 'react';
import PropTypes from 'prop-types';

const YoutubePlayer = ({
    additionalClass,
    autoplay,
    controls,
    frameBorder,
    height,
    showinfo,
    title,
    videoURL,
    width,
}) => {
    let videoID = videoURL.split('v=')[1];
    const ampersandPosition = videoID.indexOf('&');
    if (ampersandPosition !== -1) {
        videoID = videoID.substring(0, ampersandPosition);
    }

    const src = `https://www.youtube.com/embed/${videoID}
        ?autoplay=${Number(autoplay)}
        &controls=${Number(controls)}
        &rel=0
        &showinfo=${Number(showinfo)}`.replace(/\s/g, '');

    return (
        <iframe
            id="ytplayer"
            title={title}
            className={additionalClass}
            type="text/html"
            width={width}
            height={height}
            src={src}
            frameBorder={frameBorder}
        />
    );
};

YoutubePlayer.defaultProps = {
    additionalClass: '',
    autoplay: false,
    controls: true,
    frameBorder: false,
    height: '100%',
    showinfo: false,
    title: 'Youtube video player',
    width: '100%',
};

YoutubePlayer.propTypes = {
    additionalClass: PropTypes.string,
    autoplay: PropTypes.bool,
    controls: PropTypes.bool,
    frameBorder: PropTypes.bool,
    height: PropTypes.number,
    showinfo: PropTypes.bool,
    title: PropTypes.string,
    videoURL: PropTypes.string.isRequired,
    width: PropTypes.number,
};

export default YoutubePlayer;



// WEBPACK FOOTER //
// ./src/components/YoutubePlayer/YoutubePlayer.jsx